import { render, staticRenderFns } from "./putOnRecord.vue?vue&type=template&id=d2601da6&scoped=true&"
import script from "./putOnRecord.vue?vue&type=script&lang=js&"
export * from "./putOnRecord.vue?vue&type=script&lang=js&"
import style0 from "./putOnRecord.vue?vue&type=style&index=0&id=d2601da6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2601da6",
  null
  
)

export default component.exports